import { render, staticRenderFns } from "./DiceCard.vue?vue&type=template&id=a5a52e64&"
import script from "./DiceCard.vue?vue&type=script&lang=js&"
export * from "./DiceCard.vue?vue&type=script&lang=js&"
import style0 from "./DiceCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports